import { PlusCircleFilled, QuestionCircleOutlined } from '@ant-design/icons';
import { useNavigate } from '@umijs/max';
import { Button, Dropdown } from 'antd';
import { createStyles } from 'antd-style';

export type SiderTheme = 'light' | 'dark';

const useStyle = createStyles(({ prefixCls, css }) => ({
  linearGradientButton: css`
    &.${prefixCls}-btn-primary:not([disabled]):not(
        .${prefixCls}-btn-dangerous
      ) {
      border-width: 0;

      > span {
        position: relative;
      }

      &::before {
        content: '';
        // background: linear-gradient(135deg, #174ea6, #63e6ff);
        position: absolute;
        inset: 0;
        opacity: 1;
        transition: all 0.3s;
        border-radius: inherit;
      }

      &:hover::before {
        opacity: 0;
      }
    }
  `,
}));

export const AddDropdown = () => {
  const { styles } = useStyle();
  const navigate = useNavigate();
  return (
    <Dropdown
      menu={{
        items: [
          {
            label: '上传文档',
            key: 'upload',
          },
          {
            label: '撰写经验',
            key: 'experience',
          },
          {
            label: '添加协作',
            key: 'task',
          },
          {
            label: '创建课程',
            key: 'course',
          },
        ],
        onClick: (e) => {
          if (e.key === 'upload') {
            navigate('/manage/document/upload/0');
          } else if (e.key === 'experience') {
            navigate('/manage/document/experience/0');
          } else if (e.key === 'task') {
            navigate('/manage/document/task/0');
          } else if (e.key === 'course') {
            navigate('/course/create');
          }
        },
      }}
    >
      <Button
        size="middle"
        icon={<PlusCircleFilled />}
        className={styles.linearGradientButton}
        type="primary"
      >
        快速添加
      </Button>
    </Dropdown>
  );
};

export const Question = () => {
  return (
    <div
      style={{
        display: 'flex',
        height: 26,
      }}
      onClick={() => {
        window.open('https://pro.ant.design/docs/getting-started');
      }}
    >
      <QuestionCircleOutlined />
    </div>
  );
};
